import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@environment/environment';
import { catchError, map } from 'rxjs/operators';

export interface NotificationOutboxEntry {
  ID: number;
  event_type: string;
  aggregate_type: string;
  aggregate_id: number;
  recipient_user_id: number;
  recipient_email: string;
  supervisor_email: string;
  payload_json: string;
  status: string;
  attempts: number;
  last_error: string;
  created_at: string;
  sent_at: string;
}

export interface NotificationOutboxResponse {
  records: NotificationOutboxEntry[];
  total: number;
}

@Injectable({ providedIn: 'root' })
export class NotificationService {
  constructor(private httpClient: HttpClient) { }

  getNotificationsToManage() {
    return this.httpClient.get<any>(`${environment.apiEndPoint}notifications/read_manage`)
      .pipe(
        map(res => res ? res.document as NotificationOutboxResponse : null),
        catchError(this.handleError)
      );
  }

  retryNotification(id: number) {
    return this.httpClient.post<any>(`${environment.apiEndPoint}notifications/process`, { id })
      .pipe(catchError(this.handleError));
  }

  private handleError(error: any): Promise<any> {
    let retour = error?.error?.message || error?.message || error;
    if (error?.error?.data) retour += '<br />' + error?.error?.data;
    return Promise.reject(retour);
  }
}
